import '@/style/index.scss'
import { VueQueryPlugin } from '@tanstack/vue-query'
import 'uno.css'
import { createSSRApp } from 'vue'
import './static/font/iconfont.css'

import App from './App.vue'
import { prototypeInterceptor, requestInterceptor, routeInterceptor } from './interceptors'
import store from './store'
// #ifdef H5
import VConsole from 'vconsole'
// #endif

uni.$zp = {
  config: {
    //配置分页默认pageSize为10
    'default-page-size': 10,
    'hide-no-more-by-limit': 5,
    //配置空数据图默认描述文字为：空空如也~~
    'empty-view-text': '空空如也~~',
    //...
  },
}

export function createApp() {
  const app = createSSRApp(App)
  app.use(store)
  app.use(routeInterceptor)
  app.use(requestInterceptor)
  app.use(prototypeInterceptor)
  app.use(VueQueryPlugin)
  // #ifdef H5
  if (import.meta.env.VITE_APP_ENV !== 'production') {
    const vConsole: any = new VConsole()
    app.use(vConsole)
  }
  // #endif

  return {
    app,
  }
}
